import { gql } from '@apollo/client';
import {
  BASE_PLOT_FRAGMENT,
  NEIGHBOURING_PLOT_FRAGMENT,
  PLOT_FRAGMENT,
  EXTENDED_PLOT_FRAGMENT,
} from 'graphql/secure/fragments/plot.fragment';
import { DOCUMENT_FRAGMENT } from '../fragments/document.fragments';

export const GET_PLOTS = gql`
  query GetPlots($filters: PlotsFilters, $first: Int, $after: String, $before: String, $last: Int) {
    plots(first: $first, after: $after, before: $before, last: $last, filters: $filters) {
      edges {
        node {
          ...basePlotValues
        }
      }
      count
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${BASE_PLOT_FRAGMENT}
`;

export const GET_PLOTS_WITH_FARMS = gql`
  query GetPlots(
    $filters: PlotsFilters
    $orderBy: PlotsOrderBy
    $first: Int
    $after: String
    $before: String
    $last: Int
  ) {
    plots(
      first: $first
      after: $after
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...plotValues
        }
      }
      count
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${PLOT_FRAGMENT}
`;

export const GET_NEIGHBOURING_PLOTS = gql`
  query GetNeighbouringPlots($input: NeighbouringPlotsInput!) {
    neighbouringPlots(input: $input) {
      edges {
        node {
          ...neighboringPlotValues
        }
      }
      count
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${NEIGHBOURING_PLOT_FRAGMENT}
`;

export const GET_BASE_PLOT = gql`
  query GetBasePlot($id: UUID!) {
    plot(id: $id) {
      ...basePlotValues
    }
  }
  ${BASE_PLOT_FRAGMENT}
`;

export const GET_PLOT = gql`
  query GetPlot($id: UUID!) {
    plot(id: $id) {
      ...plotValues
    }
  }
  ${PLOT_FRAGMENT}
`;

// Todo: change siteId to plotId when backend ready
export const GET_PLOT_OVERVIEW = gql`
  query GetPlotOverview($id: UUID!, $lang: Language) {
    plot(id: $id) {
      ...extendedPlotValues
    }
    documents(first: 4, filters: { plotIds: [$id] }) {
      edges {
        node {
          ...documentValues
        }
      }
      count
    }
    sharedDocuments(first: 4, filters: { plotIds: [$id] }) {
      edges {
        node {
          ...documentValues
        }
      }
      count
    }
  }
  ${EXTENDED_PLOT_FRAGMENT}
  ${DOCUMENT_FRAGMENT}
`;
